import styled, { css } from "styled-components";
import { breakpoints } from "@tvg/design-system";

export const Container = styled.div<{ isFDR?: boolean }>`
  display: flex;
  flex-direction: column;
  @media screen and ${breakpoints.tablet.min.sm} {
    padding-bottom: 16px;
    ${({ isFDR }) =>
      isFDR &&
      css`
        padding: 16px;
      `};
  }
`;

export const FixedBannerContainer = styled.div`
  position: sticky;
  top: 44px;
  width: 100%;
  z-index: 10;
`;
